<template>
  <footer class="footer-professional" ref="footerRef">
    <!-- Parte superior -->
    <div class="footer-top">
      <!-- Marca -->
      <div class="footer-brand">
        <h3>EA MAGIC CLEANING LLC</h3>
        <p>Tu espacio, siempre impecable</p>
      </div>

      <!-- Contacto -->
      <div class="footer-contact">
        <h4>Contáctanos</h4>
        <div class="contact-methods">
          <a href="tel:+16122619287" class="contact-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328z"/>
            </svg>
            (612) 261-9287
          </a>
          <a href="mailto:eamagiccleaning@gmail.com" class="contact-link">
            ✉ eamagiccleaning@gmail.com
          </a>
          <p class="contact-address">Minnesota </p>
        </div>
      </div>

      <!-- Redes sociales -->
      <div class="footer-social">
        <h4>Síguenos</h4>
        <div class="social-icons">
         <div class="social-icons">
  <!-- TikTok -->


  <!-- Facebook -->
  <a href="https://www.facebook.com/share/1EFrEHeDam/?mibextid=wwXIfr " target="_blank" rel="noopener">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
    </svg>
  </a>
</div>
  </div>
      </div>
    </div>

    <!-- Parte inferior -->
    <div class="footer-bottom">
      <p class="footer-copyright">
        © 2025 EA MAGIC CLEANING LLC. Todos los derechos reservados.
      </p>
    </div>
  </footer>
</template>

<script>
import { ref, onMounted } from "vue"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

export default {
  name: "ProfessionalFooter",
  setup() {
    const footerRef = ref(null)

    onMounted(() => {
      gsap.from(footerRef.value.querySelectorAll(".footer-top > div"), {
        opacity: 0,
        y: 40,
        duration: 1,
        stagger: 0.3,
        ease: "power2.out",
        scrollTrigger: {
          trigger: footerRef.value,
          start: "top 85%",
          once: true
        }
      })
    })

    return { footerRef }
  }
}
</script>

<style scoped>
.footer-professional {
  position: relative;
  background: 
    linear-gradient(to bottom, rgba(21,21,21,0.95), rgba(26,26,26,0.95)),
    url('@/assets/ciudad.jpg') center/cover no-repeat;
  color: white;
  padding: 100px 5% 40px;
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}

.footer-professional::before {
  content: '';
  position: absolute;
  top: -12vw;
  left: 0;
  width: 100%;
  height: 15vw;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transform: skewY(-4deg);
  transform-origin: top left;
  z-index: 0;
  pointer-events: none;
}

.footer-top {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
  max-width: 1200px;
  margin-inline: auto;
}

.footer-brand h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.footer-brand p {
  font-size: 0.9rem;
  color: #bdc3c7;
}

.footer-contact h4,
.footer-social h4 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #f1f1f1;
}

.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s;
  font-size: 0.9rem;
}

.contact-link:hover {
  color: white;
}

.contact-address {
  font-size: 0.85rem;
  color: #aaa;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icons a {
  color: #fff;
  background: rgba(255,255,255,0.15);
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.social-icons a:hover {
  background: #2c82c9;
}

.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.1);
  padding-top: 25px;
  text-align: center;
}

.footer-copyright {
  font-size: 0.85rem;
  color: #aaa;
}
</style>
